/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

import * as Sentry from "@sentry/angular";
import {environment} from "./environments/environment";
import {beforeBreadcrumb, beforeSend, beforeSendSpan, beforeSendTransaction} from "@shared/utils/sentry-scrubber";


if (environment.sentryDsnAngular) {
    Sentry.init({
        dsn: environment.sentryDsnAngular,
        environment: environment.envName,
        sendDefaultPii: false,
        integrations: [
            Sentry.browserTracingIntegration()
        ],
        tracesSampleRate: environment.sentryTracesSampleRate,
        tracePropagationTargets: [],
        enableLogs: false,
        beforeSend,
        beforeSendTransaction,
        beforeSendSpan,
        beforeBreadcrumb
    });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
